import React, { useEffect, useState } from 'react';
import { FiArrowRight } from 'react-icons/fi';

import bestBike from '../../images/project-images/6.png';
import abroadPortals from '../../images/project-details/abroad-portals/1.jpg';
import jobHunter from '../../images/project-images/10.png';
import jobNexus from '../../images/project-images/11.png';
import bestBike1 from '../../images/project-images/8.png';
import creativeCaptures from '../../images/project-images/2.png';
import quizmania from '../../images/project-images/7.png';
import learnerAcademy from '../../images/project-images/1.png';
import worldCup from '../../images/project-details/world-cup/1.png';
import floodDonation from '../../images/project-details/donate-food/1.png';
import learnerHome from '../../images/project-details/learners-home/1.png';
import weddingBell from '../../images/project-details/wedding-bell/1.png';
import pandaMart from '../../images/project-details/panda-mart/1.png';
import cricket from '../../images/project-details/cricket-tournament/2.png';
import calculator from '../../images/project-details/calculator/1.png';
import newsExpress from '../../images/project-details/news-express/1.png';
import phoneFinder from '../../images/project-details/phone-finder/1.png';
import dailyTasks from '../../images/project-details/daily-tasks/1.png';



import AOS from 'aos';
import 'aos/dist/aos.css';

import { Link, NavLink } from 'react-router-dom';
import './AllProjects.module.css'







import AbroadPortalsLarge from '../../images/projects-large-image/AbroadPortals.png';
import DoctorsPortalLarge from '../../images/projects-large-image/DoctorsPortal.png';
import BestBikesLarge from '../../images/projects-large-image/BestBikes.png';
import CreativeCapturesLarge from '../../images/projects-large-image/CreativeCaptures.png';
import LearnerAcademyLarge from '../../images/projects-large-image/LearnerAcademy.png';
import LearnerHomeLarge from '../../images/projects-large-image/LearnerHome.png';
import NewsExpressLarge from '../../images/projects-large-image/NewsExpress.png';
import PandaMartLarge from '../../images/projects-large-image/PandaMart.png';
import QuizManiaLarge from '../../images/projects-large-image/QuizMania1.png';
import SelectFiveLarge from '../../images/projects-large-image/SelectFive.png';
import WeddingBellLarge from '../../images/projects-large-image/WeddingBell.png';
import FloodDonationLarge from '../../images/projects-large-image/Flood.png';
import FootballWorldCupLarge from '../../images/projects-large-image/FootballWorldCup.png';
import StudyBlogsLarge from '../../images/projects-large-image/StudyBlogs.png';









import 'animate.css';
import { CSSTransition } from 'react-transition-group';
import './AllProjects.css'
import { useLanguage } from '../../context/LanguageContext';















const AllProjects = () => {


    const { language } = useLanguage();


    useEffect(() => {
        AOS.init({
            duration: 1000
        })
    }, [])

    const [starting, setStarting] = useState(true)
    const [allProjects, setAllProjects] = useState(false);
    const [HTMLCSS, setHTMLCSS] = useState(false);
    const [javaScript, setJavaScript] = useState(false);
    const [myEveryProjects, setMyEveryProjects] = useState(false);
    const [activeHTML, setActiveHTML] = useState(false);
    const [activeJavaScript, setActiveJavaScript] = useState(false);
    const [activeFullStack, setActiveFullStack] = useState(false);
    const [activeMyAllProjects, setActiveMyAllProjects] = useState(false);



    const handleAllProjects = () => {
        setAllProjects(true);
        setHTMLCSS(false);
        setJavaScript(false);
        setStarting(false);
        setMyEveryProjects(false);
        setActiveHTML(false);
        setActiveJavaScript(false);
        setActiveFullStack(!activeFullStack);
        setActiveMyAllProjects(false);
    }

    const handleHTMLCSS = () => {
        setAllProjects(false);
        setHTMLCSS(true);
        setJavaScript(false);
        setStarting(false);
        setMyEveryProjects(false);
        setActiveHTML(!activeHTML);
        setActiveJavaScript(false);
        setActiveFullStack(false);
        setActiveMyAllProjects(false);
    }

    const handleJavaScript = () => {
        setAllProjects(false);
        setHTMLCSS(false);
        setJavaScript(true);
        setStarting(false);
        setMyEveryProjects(false);
        setActiveHTML(false);
        setActiveJavaScript(!activeJavaScript);
        setActiveFullStack(false);
        setActiveMyAllProjects(false);
    }


    const handleMyEveryProjects = () => {
        setMyEveryProjects(true)
        setAllProjects(false);
        setHTMLCSS(false);
        setJavaScript(false);
        setStarting(false);
        setActiveHTML(false);
        setActiveJavaScript(false);
        setActiveFullStack(false);
        setActiveMyAllProjects(!activeMyAllProjects);
    }








    //Abroad Portals card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const abroadPortalsDivStyle = {
        backgroundImage: ` url(${AbroadPortalsLarge})`,
        transition: 'ease-in 8s',
    };
    const abroadPortalsHandleHover = () => {
        abroadPortalsDivStyle.transition = 'ease 8s';
    };
    const abroadPortalsHandleUnHover = () => {
        abroadPortalsDivStyle.transition = 'ease 1s'
    };


    //Abroad Portals card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const studyBlogsDivStyle = {
        backgroundImage: ` url(${StudyBlogsLarge})`,
        transition: 'ease-in 6s',
    };
    const studyBlogsHandleHover = () => {
        studyBlogsDivStyle.transition = 'ease 6s';
    };
    const studyBlogsHandleUnHover = () => {
        studyBlogsDivStyle.transition = 'ease 1s'
    };


    //Doctors Portal card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const doctorsPortalDivStyle = {
        backgroundImage: ` url(${DoctorsPortalLarge})`,
        transition: 'ease-in 7s',
    };
    const doctorsPortalHandleHover = () => {
        doctorsPortalDivStyle.transition = 'ease 7s';
    };
    const doctorsPortalHandleUnHover = () => {
        doctorsPortalDivStyle.transition = 'ease 1s'
    };


    //Best Bikes card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const bestBikesDivStyle = {
        backgroundImage: ` url(${BestBikesLarge})`,
        transition: 'ease-in 5s',
    };
    const bestBikesHandleHover = () => {
        bestBikesDivStyle.transition = 'ease 5s';
    };
    const bestBikesHandleUnHover = () => {
        bestBikesDivStyle.transition = 'ease 1s'
    };



    //Creative Captures card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const creativeCapturesDivStyle = {
        backgroundImage: ` url(${CreativeCapturesLarge})`,
        transition: 'ease-in 5s',
    };
    const creativeCapturesHandleHover = () => {
        creativeCapturesDivStyle.transition = 'ease 5s';
    };
    const creativeCapturesHandleUnHover = () => {
        creativeCapturesDivStyle.transition = 'ease 1s'
    };


    // Learner Academy card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const learnerAcademyDivStyle = {
        backgroundImage: ` url(${LearnerAcademyLarge})`,
        transition: 'ease-in 4s',
    };
    const learnerAcademyHandleHover = () => {
        learnerAcademyDivStyle.transition = 'ease 4s';
    };
    const learnerAcademyHandleUnHover = () => {
        learnerAcademyDivStyle.transition = 'ease 1s'
    };



    // Quiz Mania card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const quizManiaDivStyle = {
        backgroundImage: ` url(${QuizManiaLarge})`,
        transition: 'ease-in 5s',
    };
    const quizManiaHandleHover = () => {
        quizManiaDivStyle.transition = 'ease 5s';
    };
    const quizManiaHandleUnHover = () => {
        quizManiaDivStyle.transition = 'ease 1s'
    };


    // News Express card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const newsExpressDivStyle = {
        backgroundImage: ` url(${NewsExpressLarge})`,
        transition: 'ease-in 9s',
    };
    const newsExpressHandleHover = () => {
        newsExpressDivStyle.transition = 'ease 9s';
    };
    const newsExpressHandleUnHover = () => {
        newsExpressDivStyle.transition = 'ease 1s'
    };


    // Select Best 5 card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const selectFiveDivStyle = {
        backgroundImage: ` url(${SelectFiveLarge})`,
        transition: 'ease-in 4s',
    };
    const selectFiveHandleHover = () => {
        selectFiveDivStyle.transition = 'ease 4s';
    };
    const selectFiveHandleUnHover = () => {
        selectFiveDivStyle.transition = 'ease 1s'
    };


    // Wedding Bell  card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const weddingBellDivStyle = {
        backgroundImage: ` url(${WeddingBellLarge})`,
        transition: 'ease-in 4s',
    };
    const weddingBellHandleHover = () => {
        weddingBellDivStyle.transition = 'ease 4s';
    };
    const weddingBellHandleUnHover = () => {
        weddingBellDivStyle.transition = 'ease 1s'
    };


    // Panda Mart card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const pandaMartDivStyle = {
        backgroundImage: ` url(${PandaMartLarge})`,
        transition: 'ease-in 4s',
    };
    const pandaMartHandleHover = () => {
        pandaMartDivStyle.transition = 'ease 4s';
    };
    const pandaMartHandleUnHover = () => {
        pandaMartDivStyle.transition = 'ease 1s'
    };


    // Learner Home card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const learnerHomeDivStyle = {
        backgroundImage: ` url(${LearnerHomeLarge})`,
        transition: 'ease-in 8s',
    };
    const learnerHomeHandleHover = () => {
        learnerHomeDivStyle.transition = 'ease 8s';
    };
    const learnerHomeHandleUnHover = () => {
        learnerHomeDivStyle.transition = 'ease 1s'
    };



    // Flood Donation card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const floodDonationDivStyle = {
        backgroundImage: ` url(${FloodDonationLarge})`,
        transition: 'ease-in 6s',
    };
    const floodDonationHandleHover = () => {
        floodDonationDivStyle.transition = 'ease 6s';
    };
    const floodDonationHandleUnHover = () => {
        floodDonationDivStyle.transition = 'ease 1s'
    };



    // Football World Cup card er pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const footballWorldCupDivStyle = {
        backgroundImage: ` url(${FootballWorldCupLarge})`,
        transition: 'ease-in 4s',
    };
    const footballWorldCupHandleHover = () => {
        footballWorldCupDivStyle.transition = 'ease 4s';
    };
    const footballWorldCupHandleUnHover = () => {
        footballWorldCupDivStyle.transition = 'ease 1s'
    };
















    const [show, setShow] = useState(false);











    return (
        <div className='mb-36 mt-36'>

            {
                language === 'english' ?
                    <>
                        <h1 className='uppercase text-center text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-mono sm:mt-4 md:mt-0 mt-4'>More <span className='md:text-6xl text-5xl text-rose-600'>Projects</span><hr className='mx-auto mt-4 ' width="180px" /></h1>
                    </>
                    :
                    <>
                        <h1 className='uppercase text-center text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-mono sm:mt-4 md:mt-0 mt-4'>আরো <span className='md:text-6xl text-5xl text-rose-600'>প্রজেক্ট</span><hr className='mx-auto mt-4 ' width="180px" /></h1>

                    </>
            }

            <div className=' grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-x-8 lg:gap-y-0 md:gap-y-12 sm:gap-y-2 gap-y-2 lg:px-20 md:px-6 sm:px-2 px-4 text-center mt-8 mb-16'>

                <div onClick={handleMyEveryProjects} className='relative group mt-12 tooltip'  data-tip='View All Projects'>
                    <div className='absolute -inset-0.5 mt-4 rounded-md blur bg-gradient-to-r from-lime-400 to-green-500 opacity-60 group-hover:opacity-80 transition duration-300 '>
                    </div>
                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-md leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-1 group-hover:scale-102' style={{ backgroundColor: !activeMyAllProjects ? "black" : "#38393a" }}>
                        <div className='flex space-x-3 justify-center items-center'>
                            {
                                language === 'english' ?
                                    <h1>All Projects</h1>
                                    :
                                    <h1>সকল প্রজেক্ট</h1>
                            }
                        </div>
                    </button>
                </div>


                <div onClick={handleAllProjects} className='relative group mt-12 tooltip' data-tip='View Full Stack Projects'>
                    <div className='absolute -inset-0.5 mt-4 rounded-md blur bg-gradient-to-r from-pink-500 to-violet-600 opacity-60 group-hover:opacity-80 transition duration-300 '>
                    </div>
                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-md leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-1 group-hover:scale-102' style={{ backgroundColor: !activeFullStack ? "black" : "#38393a" }}>
                        <div className='flex space-x-3 justify-center items-center'>
                            {
                                language === 'english' ?
                                    <h1>Full Stack</h1>
                                    :
                                    <h1>ফুল স্ট্যাক</h1>
                            }
                        </div>
                    </button>
                </div>


                <div onClick={handleJavaScript} className='relative group mt-12 tooltip' data-tip='View JavaScript Projects'> 
                    <div className='absolute -inset-0.5 mt-4 rounded-md blur bg-gradient-to-r from-yellow-400 to-amber-400 opacity-60 group-hover:opacity-80 transition duration-300 '>
                    </div>
                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-md leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-1 group-hover:scale-102' style={{ backgroundColor: !activeJavaScript ? "black" : "#38393a" }}>
                        <div className='flex space-x-3 justify-center items-center'>
                            {
                                language === 'english' ?
                                    <h1>JavaScript</h1>
                                    :
                                    <h1>জাভাস্ক্রিপ্ট</h1>
                            }
                        </div>
                    </button>
                </div>


                <div onClick={handleHTMLCSS} className='relative group mt-12 tooltip'  data-tip='View HTML & CSS Projects'>
                    <div className='absolute -inset-0.5 mt-4 rounded-md blur bg-gradient-to-r from-blue-400 to-blue-500 opacity-60 group-hover:opacity-80 transition duration-300 '>
                    </div>
                    <button type='submit' value="Submit" className="w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-md leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-1 group-hover:scale-102" style={{ backgroundColor: !activeHTML ? "black" : "#38393a" }}>
                        <div className='flex space-x-3 justify-center items-center'>
                            {
                                language === 'english' ?
                                    <h1>HTML & CSS</h1>
                                    :
                                    <h2 className='text-[22px]'>এইচটিএমএল & সিএসএস</h2>
                            }
                        </div>
                    </button>
                </div>


            </div>




            {
                (starting || myEveryProjects) &&

                <div>

                    {
                        language === 'english' ?
                            <h1 className='text-center text-3xl mt-32 mb-8'><span className='text-rose-600 text-3xl font-semibold'>All</span> Projects <hr className='mx-auto mt-4 ' width="180px" /></h1>
                            :
                            <h1 className='text-center text-3xl mt-32 mb-8'><span className='text-rose-600 text-3xl font-semibold'>সকল</span> প্রজেক্ট <hr className='mx-auto mt-4 ' width="180px" /></h1>
                    }


                    <div className='grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-x-8 gap-y-12 lg:px-10 md:px-6 px-2' >

                        <div className=" md:w-[330px] lg:w-[420px] w-[342px] mx-auto card card-compact bg-base-100 shadow-xxl   border-2 border-purple-600 border-b-4 border-t-0 border-r-1 border-l-0  animation" data-aos="zoom-in">
                            {/* <figure> <img src={abroadPortals} alt="Abroad" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /> </figure>*/}
                            <div className='md:mx-0  mx-auto '>
                                <div
                                    style={abroadPortalsDivStyle}
                                    onMouseEnter={abroadPortalsHandleHover}
                                    onMouseLeave={abroadPortalsHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Abroad Portals</h2>
                                <p className='text-md  text-justify'>Abroad Portals is an Educational Consultancy Firm in Bangladesh which offers services and consultancy for studying abroad. It is a community-based platform run by students.</p>
                                <p className='text-lg'>Tools: MERN, Firebase, Tailwind</p>
                                <Link to='/abroadPortalsDetails' >
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto    hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>

                            </div>
                        </div>


                        <div className=" md:w-[330px] lg:w-[420px] w-[342px]  mx-auto card card-compact bg-base-100 shadow-xxl   border-2 border-purple-600 border-b-4 border-t-0 border-r-1 border-l-0  animation" data-aos="zoom-in">
                            {/* <figure><img src={bestBike1} alt="Bikes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' md:mx-0  mx-auto'>
                                <div
                                    style={bestBikesDivStyle}
                                    onMouseEnter={bestBikesHandleHover}
                                    onMouseLeave={bestBikesHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div> 
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Best Bikes</h2>
                                <p className='text-md  text-justify'>Best Bikes is a platform for buying and selling used bikes. It has a Multi user dashboard with different features for Buyer, Seller and Admin.</p>
                                <p className='text-lg'>Tools: MERN, Firebase, Tailwind, Stripe</p>
                                <Link to='/bestBikeDetails' >
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto    hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className=" md:w-[330px] lg:w-[420px] w-[342px] mx-auto card card-compact bg-base-100 shadow-xxl   border-2 border-purple-600 border-b-4 border-t-0 border-r-1 border-l-0  animation" data-aos="zoom-in">
                            {/* <figure><img src={bestBike1} alt="DoctorsPortal" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' md:mx-0  mx-auto'>
                                <div
                                    style={doctorsPortalDivStyle}
                                    onMouseEnter={doctorsPortalHandleHover}
                                    onMouseLeave={doctorsPortalHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Doctors Portal</h2>
                                <p className='text-md  text-justify'>Online Dental clinic for different types of dental treatments. A Patient can book appointment for session and can get treatment for his/her dental problem.</p>
                                <p className='text-lg'>Tools: MERN, Firebase, Tailwind, Stripe</p>
                                <Link to='/doctorsPortalDetails' >
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto    hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="md:w-[330px] lg:w-[420px] w-[342px] mx-auto card card-compact  bg-base-100 shadow-2xl border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos="zoom-in">
                            <figure ><img src={jobHunter} alt="Job" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Job Hunter</h2>
                                <p className='text-md text-justify'>Job Hunter is a portal for job seekers where he can find and apply to different jobs posted by the employers. Candidate can chat directly to  with employers and many more</p>
                                <p className='text-lg'>Tools: MERN, Redux Firebase, Tailwind</p>
                                <Link to='/jobHunterDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto      hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="md:w-[330px] lg:w-[420px] w-[342px] mx-auto card card-compact  bg-base-100 shadow-2xl border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos="zoom-in">
                            {/* <figure ><img src={creativeCaptures} alt="Creative" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' md:mx-0  mx-auto'>
                                <div
                                    style={studyBlogsDivStyle}
                                    onMouseEnter={studyBlogsHandleHover}
                                    onMouseLeave={studyBlogsHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Study Blogs</h2>
                                <p className='text-md text-justify'>This is a website for adding and reading blogs.User can search blogs by their category and if needed they can perform CRUD operation.</p>
                                <p className='text-lg'>Tools: MERN, Redux, Firebase, Tailwind</p>
                                <Link to='/studyBlogsDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto     hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="md:w-[330px] lg:w-[420px] w-[342px]  mx-auto card card-compact  bg-base-100 shadow-2xl border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos="zoom-in">
                            <figure ><img src={jobNexus} alt="Job" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Job Nexus</h2>
                                <p className='text-md text-justify'> Job Nexus is a website where jobs can be posted by the authority and based on the user role an employer can perform CRUD operation to the jobs he has posted.</p>
                                <p className='text-lg'>Tools: MERN, Redux Firebase, Material UI</p>
                                <Link to='/jobNexusDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto   hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className=" md:w-[330px] lg:w-[420px] w-[342px] mx-auto shadow-2xl card card-compact  bg-base-100  border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos="zoom-in">
                            <figure><img src={dailyTasks} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Daily Tasks</h2>
                                <p className='text-md text-justify'>Daily Tasks is a task management website which helps an individual to manage his day to day tasks. It also helps one to be updated with the completed tasks</p>
                                <p className='text-lg'>Tools: MERN, Firebase, Tailwind</p>
                                <Link to='/dailyTasksDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto   hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="md:w-[330px] lg:w-[420px] w-[342px] mx-auto card card-compact  bg-base-100 shadow-2xl border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos="zoom-in">
                            {/* <figure ><img src={creativeCaptures} alt="Creative" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' md:mx-0  mx-auto'>
                                <div
                                    style={creativeCapturesDivStyle}
                                    onMouseEnter={creativeCapturesHandleHover}
                                    onMouseLeave={creativeCapturesHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Creative Captures</h2>
                                <p className='text-md text-justify'>Creative Captures is a online Photography Service Review platform where  user can add reviews of the services he/she has availed for.</p>
                                <p className='text-lg'>Tools: MERN, Firebase, Tailwind</p>
                                <Link to='/creativeCapturesDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto   hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="md:w-[330px] lg:w-[420px] w-[342px] mx-auto shadow-2xl card card-compact  bg-base-100  border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos="zoom-in">
                            {/* <figure><img src={learnerAcademy} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' md:mx-0  mx-auto'>
                                <div
                                    style={learnerAcademyDivStyle}
                                    onMouseEnter={learnerAcademyHandleHover}
                                    onMouseLeave={learnerAcademyHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Learner Academy</h2>
                                <p className='text-md text-justify'>Learner Academy is a online platform which provides different courses related to computer science and programming languages.</p>
                                <p className='text-lg'>Tools: React JS, Firebase, Bootstrap</p>
                                <Link to='/learnerAcademyDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto   hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="md:w-[330px] lg:w-[420px] w-[342px] mx-auto card card-compact  bg-base-100 shadow-2xl border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos="zoom-in">
                            {/* <figure><img src={quizmania} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' md:mx-0  mx-auto'>
                                <div
                                    style={quizManiaDivStyle}
                                    onMouseEnter={quizManiaHandleHover}
                                    onMouseLeave={quizManiaHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Quiz Mania</h2>
                                <p className='text-md text-justify'>Quiz Mania is a quiz project that helps the students to take part in quizzes of different computer science related courses. After submitting they can know the mark also</p>
                                <p className='text-lg'>Tools: React JS, Firebase, Bootstrap</p>
                                <Link to='/quizManiaDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto         hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="md:w-[330px] lg:w-[420px] w-[342px] mx-auto card card-compact  bg-base-100 shadow-2xl border-2  border-amber-500 border-b-2 border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure ><img src={newsExpress} alt="Creative" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' md:mx-0  mx-auto'>
                                <div
                                    style={newsExpressDivStyle}
                                    onMouseEnter={newsExpressHandleHover}
                                    onMouseLeave={newsExpressHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">News Express</h2>
                                <p className='text-md text-justify'>News Express is an online news portal which shows daily news based on different news categories. News are fetched by API call</p>
                                <p className='text-lg'>Tools: HTML, Bootstrap, JavaScript</p>
                                <Link to='/newsExpressDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto        hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="md:w-[330px] lg:w-[420px] w-[342px] mx-auto card card-compact  bg-base-100 shadow-2xl border-2  border-amber-500 border-b-2 border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            <figure ><img src={phoneFinder} alt="Creative" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Phone Finder</h2>
                                <p className='text-md text-justify'>Phone Finder is a website where you can find your desire phone by searching. All phone are shown by API call </p>
                                <p className='text-lg'>Tools: HTML, Bootstrap, JavaScript</p>
                                <Link to='/phoneFinderDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto     hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="md:w-[330px] lg:w-[420px] w-[342px] mx-auto card card-compact bg-base-100 shadow-xxl   border-2 border-amber-500 border-b-2 border-t-0 border-r-1 border-l-0  animation" data-aos='zoom-in'>
                            {/* <figure><img src={cricket} alt="Bikes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' md:mx-0  mx-auto'>
                                <div
                                    style={selectFiveDivStyle}
                                    onMouseEnter={selectFiveHandleHover}
                                    onMouseLeave={selectFiveHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Select Best 5</h2>
                                <p className='text-md  text-justify'>It is a website made using JavaScript for selecting best 5 players from a team. It will calculate total price of player, manager and coach</p>
                                <p className='text-lg'>Tools: HTML, Bootstrap, JavaScript</p>
                                <Link to='/selectBestFiveDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto           hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className=" md:w-[330px] lg:w-[420px] w-[342px] mx-auto shadow-2xl card card-compact  bg-base-100  border-2  border-amber-500 border-b-2 border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            <figure><img src={calculator} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Calculator</h2>
                                <p className='text-md text-justify'>Calculator made by using JavaScript. It can perform the basic arithmetic operations</p>
                                <p className='text-lg'>Tools: HTML, CSS, JavaScript</p>
                                <Link to='/calculatorDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto           hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="md:w-[330px] lg:w-[420px] w-[342px] mx-auto card card-compact  bg-base-100 shadow-2xl border-2 border-blue-800 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure><img src={weddingBell} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' md:mx-0  mx-auto'>
                                <div
                                    style={weddingBellDivStyle}
                                    onMouseEnter={weddingBellHandleHover}
                                    onMouseLeave={weddingBellHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Wedding Bell</h2>
                                <p className='text-md text-justify'>Wedding Bell is a fully responsive website design created with HTML and Bootstrap which can be used for marriage convention center</p>
                                <p className='text-lg'>Tools: HTML, CSS, Bootstrap</p>
                                <Link to='/weddingBellDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto        hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="md:w-[330px] lg:w-[420px] w-[342px] mx-auto card card-compact  bg-base-100 shadow-2xl border-2 border-blue-800 border-b-4 border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure><img src={pandaMart} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' md:mx-0  mx-auto'>
                                <div
                                    style={pandaMartDivStyle}
                                    onMouseEnter={pandaMartHandleHover}
                                    onMouseLeave={pandaMartHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Panda Mart</h2>
                                <p className='text-md text-justify'>Panda Mart is a fully responsive shopping website design created with HTML and Bootstrap.</p>
                                <p className='text-lg'>Tools: HTML, CSS, Bootstrap</p>
                                <Link to='/pandaMartDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto         hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="md:w-[330px] lg:w-[420px] w-[342px] mx-auto card card-compact  bg-base-100 shadow-2xl border-2 border-blue-800 border-b-4 border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure><img src={learnerHome} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' md:mx-0  mx-auto'>
                                <div
                                    style={learnerHomeDivStyle}
                                    onMouseEnter={learnerHomeHandleHover}
                                    onMouseLeave={learnerHomeHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Learner Home</h2>
                                <p className='text-md text-justify'>Learner Home is a fully responsive website design for online computer science course materials with teacher details. </p>
                                <p className='text-lg'>Tools: HTML, CSS, Bootstrap</p>
                                <Link to='/learnerHomeDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto             hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className=" md:w-[330px] lg:w-[420px] w-[342px] mx-auto shadow-2xl card card-compact  bg-base-100  border-2  border-blue-800 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure><img src={floodDonation} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' md:mx-0  mx-auto'>
                                <div
                                    style={floodDonationDivStyle}
                                    onMouseEnter={floodDonationHandleHover}
                                    onMouseLeave={floodDonationHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Flood Donation</h2>
                                <p className='text-md text-justify'>Flood Donation is a HTML and CSS based website design which can be used as donation website for the flood affected people</p>
                                <p className='text-lg'>Tools: HTML, Raw CSS</p>
                                <Link to='/floodDonationDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto          hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>



                        <div className="md:w-[330px] lg:w-[420px] w-[342px]  mx-auto card card-compact  bg-base-100 shadow-2xl border-2  border-blue-800 border-b-4 border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure ><img src={worldCup} alt="Creative" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' md:mx-0  mx-auto'>
                                <div
                                    style={footballWorldCupDivStyle}
                                    onMouseEnter={footballWorldCupHandleHover}
                                    onMouseLeave={footballWorldCupHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">World Cup</h2>
                                <p className='text-md text-justify'>World Cup is a HTML and CSS based project that shows match fixtures and some blogs about teams. It has two different clickable routes</p>
                                <p className='text-lg'>Tools: HTML and Raw CSS</p>
                                <Link to='/worldCupDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto           hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>

                    </div>
                </div>
            }









            {
                allProjects &&

                <div>

                    {
                        language === 'english' ?
                            <h1 className='text-center text-3xl mt-32 mb-8'><span className='text-rose-600 text-3xl font-semibold'>Full  Stack </span>Projects <hr className='mx-auto mt-4 ' width="180px" /></h1>
                            :
                            <h1 className='text-center text-3xl mt-32 mb-8'><span className='text-rose-600 text-3xl font-semibold'>পূর্ণ স্ট্যাক </span>প্রজেক্ট <hr className='mx-auto mt-4 ' width="180px" /></h1>
                    }

                    <div className='grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-x-8 gap-y-12 lg:px-10 md:px-6 px-2'>

                        <div className="md:w-[330px] lg:w-[420px] w-[342px] mx-auto card card-compact bg-base-100 shadow-xxl   border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0  animation" data-aos='zoom-in' >
                            {/* <figure><img src={abroadPortals} alt="Abroad" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className='md:mx-0  mx-auto'>
                                <div
                                    style={abroadPortalsDivStyle}
                                    onMouseEnter={abroadPortalsHandleHover}
                                    onMouseLeave={abroadPortalsHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Abroad Portals</h2>
                                <p className='text-md  text-justify'>Abroad Portals is an Educational Consultancy Firm in Bangladesh which offers services and consultancy for studying abroad. It is a community-based platform run by students.</p>
                                <p className='text-lg'>Tools: MERN, Firebase, Tailwind</p>
                                <Link to='/abroadPortalsDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto          hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="mx-auto     md:w-[330px] lg:w-[420px] w-[342px] card card-compact bg-base-100 shadow-xxl   border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0  animation" data-aos='zoom-in' >
                            {/* <figure><img src={bestBike1} alt="Bikes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className='md:mx-0  mx-auto'>
                                <div
                                    style={bestBikesDivStyle}
                                    onMouseEnter={bestBikesHandleHover}
                                    onMouseLeave={bestBikesHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Best Bikes</h2>
                                <p className='text-md  text-justify'>Best Bikes is a platform for buying and selling used bikes. It has a Multiuser dashboard with different features for Buyer, Seller and Admin.</p>
                                <p className='text-lg'>Tools: MERN, Firebase, Tailwind, Stripe</p>
                                <Link to='/bestBikeDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto      hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="mx-auto     md:w-[330px] lg:w-[420px] w-[342px] card card-compact bg-base-100 shadow-xxl   border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0  animation" data-aos='zoom-in' >
                            <div className='md:mx-0  mx-auto'>
                                <div
                                    style={doctorsPortalDivStyle}
                                    onMouseEnter={doctorsPortalHandleHover}
                                    onMouseLeave={doctorsPortalHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Doctors Portal</h2>
                                <p className='text-md  text-justify'>Online Dental clinic for different types of dental treatments. A Patient can book appointment for session and can get treatment for his/her dental problem.</p>
                                <p className='text-lg'>Tools: MERN, Firebase, Tailwind, Stripe</p>
                                <Link to='/bestBikeDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto          hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="mx-auto  md:w-[330px] lg:w-[420px] w-[342px] card card-compact  bg-base-100 shadow-2xl border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos="zoom-in">
                            <figure ><img src={jobHunter} alt="Job" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Job Hunter</h2>
                                <p className='text-md text-justify'>Job Hunter is a portal for job seekers where he can find and apply to different jobs posted by the employers. Candidate can chat directly to  with employers and many more</p>
                                <p className='text-lg'>Tools: MERN, Redux Firebase, Tailwind</p>
                                <Link to='/jobHunterDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto           hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="md:w-[330px] lg:w-[420px] w-[342px] mx-auto card card-compact  bg-base-100 shadow-2xl border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos="zoom-in">
                            {/* <figure ><img src={creativeCaptures} alt="Creative" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className=' md:mx-0  mx-auto'>
                                <div
                                    style={studyBlogsDivStyle}
                                    onMouseEnter={studyBlogsHandleHover}
                                    onMouseLeave={studyBlogsHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Study Blogs</h2>
                                <p className='text-md text-justify'>This is a website for adding and reading blogs.User can search blogs by their category and if needed they can perform CRUD operation.</p>
                                <p className='text-lg'>Tools: MERN, Redux, Firebase, Tailwind</p>
                                <Link to='/studyBlogsDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto           hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="mx-auto  md:w-[330px] lg:w-[420px] w-[342px] card card-compact  bg-base-100 shadow-2xl border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos="zoom-in">
                            <figure ><img src={jobNexus} alt="Job" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Job Nexus</h2>
                                <p className='text-md text-justify'> Job Nexus is a website where jobs can be posted by the authority and based on the user role an employer can perform CRUD operation to the jobs he has posted.</p>
                                <p className='text-lg'>Tools: MERN, Redux Firebase, Material UI</p>
                                <Link to='/jobNexusDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto         hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="mx-auto  md:w-[330px] lg:w-[420px] w-[342px] card card-compact  bg-base-100 shadow-2xl border-2  border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure ><img src={creativeCaptures} alt="Creative" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className='md:mx-0  mx-auto'>
                                <div
                                    style={creativeCapturesDivStyle}
                                    onMouseEnter={creativeCapturesHandleHover}
                                    onMouseLeave={creativeCapturesHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Creative Captures</h2>
                                <p className='text-md text-justify'>Creative Captures is a online Photography Service Review platform where  user can add reviews of the services he/she has availed for.</p>
                                <p className='text-lg'>Tools: MERN, Firebase, Tailwind</p>
                                <Link to='/creativeCapturesDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto     hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className=" mx-auto  md:w-[330px] lg:w-[420px] w-[342px] shadow-2xl card card-compact  bg-base-100  border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos="zoom-in">
                            <figure><img src={dailyTasks} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Daily Tasks</h2>
                                <p className='text-md text-justify'>Daily Tasks is a task management website which helps an individual to manage his daily day to day tasks. It also helps one to be updated with the completed tasks</p>
                                <p className='text-lg'>Tools: MERN, Firebase, Tailwind</p>
                                <Link to='/dailyTasksDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto     hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="mx-auto  md:w-[330px] lg:w-[420px] w-[342px] shadow-2xl card card-compact  bg-base-100  border-2  border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure><img src={learnerAcademy} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className='md:mx-0  mx-auto '>
                                <div
                                    style={learnerAcademyDivStyle}
                                    onMouseEnter={learnerAcademyHandleHover}
                                    onMouseLeave={learnerAcademyHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Learner Academy</h2>
                                <p className='text-md text-justify'>Learner Academy is a online platform which provides different courses related to computer science and programming languages.</p>
                                <p className='text-lg'>Tools: React JS, Firebase, Bootstrap</p>
                                <Link to='/learnerAcademyDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto     hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                        <div className="mx-auto  md:w-[330px] lg:w-[420px] w-[342px] card card-compact  bg-base-100 shadow-2xl border-2 border-purple-600 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure><img src={quizmania} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className='md:mx-0  mx-auto '>
                                <div
                                    style={quizManiaDivStyle}
                                    onMouseEnter={quizManiaHandleHover}
                                    onMouseLeave={quizManiaHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Quiz Mania</h2>
                                <p className='text-md text-justify'>Quiz Mania is a quiz project that helps the students to take part in quizzes of different computer science related courses. After submitting they can know the mark also</p>
                                <p className='text-lg'>Tools: React JS, Firebase, Bootstrap</p>
                                <Link to='/quizManiaDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto     hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>


                    </div>

                </div>

            }






            {
                HTMLCSS &&

                <div>


                    {
                        language === 'english' ?
                            <h1 className='text-center md:text-3xl lg:text-[27px] text-2xl mt-32 mb-8'><span className='text-rose-600 md:text-3xl lg:text-[27px] text-2xl font-semibold'>HTML & CSS</span> Projects <hr className='mx-auto mt-4 ' width="180px" /></h1>
                            :
                            <h1 className='text-center md:text-3xl lg:text-[27px] text-2xl mt-32 mb-8'><span className='text-rose-600 md:text-3xl lg:text-[27px] text-2xl font-semibold'>এইচটিএমএল & সিএসএস</span> প্রজেক্ট <hr className='mx-auto mt-4 ' width="180px" /></h1>
                    }

                    <div className='grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-x-8 gap-y-12 lg:px-10 md:px-6 px-2 ' >


                        <div className="mx-auto  md:w-[330px] lg:w-[420px] w-[342px] card card-compact  bg-base-100 shadow-2xl border-2 border-blue-800 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure><img src={weddingBell} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className='md:mx-0  mx-auto'>
                                <div
                                    style={weddingBellDivStyle}
                                    onMouseEnter={weddingBellHandleHover}
                                    onMouseLeave={weddingBellHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Wedding Bell</h2>
                                <p className='text-md text-justify'>Wedding Bell is a fully responsive website design created with HTML and Bootstrap which can be used for marriage convention center</p>
                                <p className='text-lg'>Tools: HTML, CSS, Bootstrap</p>
                                <Link to='/weddingBellDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto     hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>



                        <div className="mx-auto  md:w-[330px] lg:w-[420px] w-[342px] card card-compact  bg-base-100 shadow-2xl border-2 border-blue-800 border-b-4 border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure><img src={pandaMart} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className='md:mx-0  mx-auto '>
                                <div
                                    style={pandaMartDivStyle}
                                    onMouseEnter={pandaMartHandleHover}
                                    onMouseLeave={pandaMartHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Panda Mart</h2>
                                <p className='text-md text-justify'>Panda Mart is a fully responsive shopping website design created with HTML and Bootstrap.</p>
                                <p className='text-lg'>Tools: HTML, CSS, Bootstrap</p>
                                <Link to='/pandaMartDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto    hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>



                        <div className="mx-auto  md:w-[330px] lg:w-[420px] w-[342px] card card-compact  bg-base-100 shadow-2xl border-2 border-blue-800 border-b-4 border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure><img src={learnerHome} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className='md:mx-0  mx-auto '>
                                <div
                                    style={learnerHomeDivStyle}
                                    onMouseEnter={learnerHomeHandleHover}
                                    onMouseLeave={learnerHomeHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Learner Home</h2>
                                <p className='text-md text-justify'>Learner Home is a fully responsive website design for online computer science course materials with teacher details. </p>
                                <p className='text-lg'>Tools: HTML, CSS, Bootstrap</p>
                                <Link to='/learnerHomeDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto   hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>



                        <div className="mx-auto  md:w-[330px] lg:w-[420px] w-[342px]  shadow-2xl card card-compact  bg-base-100  border-2  border-blue-800 border-b-4  border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure><img src={floodDonation} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className='md:mx-0  mx-auto '>
                                <div
                                    style={floodDonationDivStyle}
                                    onMouseEnter={floodDonationHandleHover}
                                    onMouseLeave={floodDonationHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Flood Donation</h2>
                                <p className='text-md text-justify'>Flood Donation is a HTML and CSS based website design which can be used as donation website for the flood affected people</p>
                                <p className='text-lg'>Tools: HTML, Raw CSS</p>
                                <Link to='/floodDonationDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto    hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>



                        <div className="mx-auto  md:w-[330px] lg:w-[420px] w-[342px] card card-compact  bg-base-100 shadow-2xl border-2  border-blue-800 border-b-4 border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure ><img src={worldCup} alt="Creative" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className='md:mx-0  mx-auto '>
                                <div
                                    style={footballWorldCupDivStyle}
                                    onMouseEnter={footballWorldCupHandleHover}
                                    onMouseLeave={footballWorldCupHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">World Cup</h2>
                                <p className='text-md text-justify'>World Cup is a HTML and CSS based project that shows match fixtures and some blogs about teams. It has two different clickable routes</p>
                                <p className='text-lg'>Tools: HTML and Raw CSS</p>
                                <Link to='/worldCupDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto   hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>



                    </div>

                </div>

            }




            {
                javaScript &&

                <div>


                    {
                        language === 'english' ?
                            <h1 className='text-center text-3xl mt-32 mb-8'><span className='text-rose-600 text-3xl font-semibold'>JavaScript</span> Projects <hr className='mx-auto mt-4 ' width="180px" /></h1>
                            :
                            <h1 className='text-center text-3xl mt-32 mb-8'><span className='text-rose-600 text-3xl font-semibold'>জাভাস্ক্রিপ্ট</span> প্রজেক্ট <hr className='mx-auto mt-4 ' width="180px" /></h1>
                    }

                    <div className='grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-x-8 gap-y-12 lg:px-10 md:px-6 px-2' >



                        <div className="mx-auto  md:w-[330px] lg:w-[420px] w-[342px] card card-compact  bg-base-100 shadow-2xl border-2  border-amber-500 border-b-2 border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            {/* <figure ><img src={newsExpress} alt="Creative" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className='md:mx-0  mx-auto '>
                                <div
                                    style={newsExpressDivStyle}
                                    onMouseEnter={newsExpressHandleHover}
                                    onMouseLeave={newsExpressHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">News Express</h2>
                                <p className='text-md text-justify'>News Express is an online news portal which shows daily news based on different news categories. News are fetched by API call</p>
                                <p className='text-lg'>Tools: HTML, Bootstrap, JavaScript</p>
                                <Link to='/newsExpressDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto    hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>



                        <div className="mx-auto  md:w-[330px] lg:w-[420px] w-[342px] card card-compact  bg-base-100 shadow-2xl border-2  border-amber-500 border-b-2 border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            <figure ><img src={phoneFinder} alt="Creative" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Phone Finder</h2>
                                <p className='text-md text-justify'>Phone Finder is a website where you can find your desire phone by searching. All phone are shown by API call </p>
                                <p className='text-lg'>Tools: HTML, Bootstrap, JavaScript</p>
                                <Link to='/phoneFinderDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto    hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>



                        <div className="mx-auto  md:w-[330px] lg:w-[420px] w-[342px] card card-compact bg-base-100 shadow-xxl   border-2 border-amber-500 border-b-2 border-t-0 border-r-1 border-l-0  animation" data-aos='zoom-in'>
                            {/* <figure><img src={cricket} alt="Bikes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure> */}
                            <div className='md:mx-0  mx-auto '>
                                <div
                                    style={selectFiveDivStyle}
                                    onMouseEnter={selectFiveHandleHover}
                                    onMouseLeave={selectFiveHandleUnHover}
                                    className=" hover:cursor-pointer rounded-t-[10px] rounded-b-none bg-top bg-cover  hover:bg-bottom   lg:w-[415px] lg:h-[226px] md:w-[327px] md:h-[177px] w-[335px] sm:h-[166px] h-[166px]"></div>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Select Best 5</h2>
                                <p className='text-md  text-justify'>It is a website made using JavaScript for selecting best 5 players from a team. It will calculate total price of player, manager and coach</p>
                                <p className='text-lg'>Tools: HTML, Bootstrap, JavaScript</p>
                                <Link to='/selectBestFiveDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto     hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>



                        <div className="mx-auto  md:w-[330px] lg:w-[420px] w-[342px] shadow-2xl card card-compact  bg-base-100  border-2  border-amber-500 border-b-2 border-t-0 border-r-1 border-l-0 animation" data-aos='zoom-in'>
                            <figure><img src={calculator} alt="Shoes" className='transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' /></figure>
                            <div className="card-body">
                                <h2 className="card-title text-white text-2xl">Calculator</h2>
                                <p className='text-md text-justify'>Calculator made by using JavaScript. It can perform the basic arithmetic operations</p>
                                <p className='text-lg'>Tools: HTML, CSS, JavaScript</p>
                                <Link to='/calculatorDetails'>
                                    <div className='bg-black border-2 border-green-600  flex justify-center items-center rounded-lg px-4 w-3/4 my-4 mx-auto     hover:scale-105  hover:duration-300 hover:delay-150 hover:ease-in-out hover:border-amber-600'>
                                        <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' title='View Details'>View Details</button>
                                        <FiArrowRight className='text-2xl'></FiArrowRight>
                                    </div>
                                </Link>
                            </div>
                        </div>

                    </div>

                </div>

            }








        </div>
    );
};

export default AllProjects;